/**
 * Compare two semantic version strings
 * @param {string} version1 - First version to compare
 * @param {string} version2 - Second version to compare
 * @returns {number} - Returns 1 if version1 > version2, -1 if version1 < version2, 0 if equal, -1 on error
 */
export const compareVersions = (version1, version2) => {
  try {
    const v1Parts = version1.split('.').map(Number)
    const v2Parts = version2.split('.').map(Number)

    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const v1Part = v1Parts[i] || 0
      const v2Part = v2Parts[i] || 0

      if (v1Part > v2Part) return 1
      if (v1Part < v2Part) return -1
    }
    return 0
  } catch (error) {
    console.error('Error comparing versions:', error)
    return -1 // Assume older version on error
  }
}
